import Commonview from '../../../pages/common_view';
import Home from '../../../pages/home_page';

const HomeRouter = [
    {
        path: '/',
        element: <Commonview/>,
        redirect: '/home',
        hidden: true,
        meta: { keepAlive: true,title: '首页'},
        children: [
            {
                path: '/home',
                element:<Home/>,
                meta: { title: '首页', keepAlive: true }
            }
        ]
    },
]

export default HomeRouter
